import { IPA_ADDITIONAL_CONTRACTS } from '../../../../../utils/ipaAccess';

export const PRICE_ARCHITECTURE_CONTRACT = IPA_ADDITIONAL_CONTRACTS.PRICE_ARCHITECTURE;

export const hasPriceArchitectureAccess = (contratosAdicionais: readonly string[]) => contratosAdicionais.includes(PRICE_ARCHITECTURE_CONTRACT);
